export default "__VITE_ASSET__DP79Z_jJ__"